import { useEffect, useState } from 'react';

/**
 * 디바운스 훅
 * @param {any} value 디바운스할 값
 * @param {number} delay 지연 시간 (ms)
 * @returns {any} 디바운스된 값
 */
export function useDebounce(value, delay) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
